import type {ReactAction} from '@netx/core/bootstrap';
import {faInboxIn} from '@netx/core-icons';
import {isPublicUser} from '@netx/core-user-next/utils/isPublicUser';
import {currentCartIsNotEmpty} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Save cart
 * @param params
 * @returns Action
 */
export const cartActionSave = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-save',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.SAVE),
	enableTest: () => currentCartIsNotEmpty() && !isPublicUser(),
	icon: faInboxIn,
	get label() {
		return CART_CURRENT_ACTION_LABELS.SAVE;
	},
	...params,
});

export default cartActionSave;
